import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import ChildRegistration from "./childRegistration/childRegistration";
import FreeDownloadsRegister from "./freeDownloadsRegister/freeDownloadsRegister";
import LoginScreen from "./loginScreen/loginScreen";
import ParentRegistration from "./parentRegistration/parentRegistration";
import VerificationScreen from "./verificationScreen/verificationScreen";
import SummaryScreen from "./summaryScreen/summaryScreen";
import TestTakingScreen from "./testTakingScreen/testTakingScreen";
import FreeDownloadsOnlyPage from "./freeDownloadsOnlyPage/freeDownloadsOnlyPage";
import TestsScreen from "./testsScreen/testsScreen";
import WordFromTutors from "./wordFromTutors/wordFromTutors";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { StateProvider } from "../context/formsContext";
import { ToastContainer } from "react-toastify";
import RedirectHandler from "../common/redirectHandler/redirectHandler";
import ReactGA from "react-ga4";


ReactGA.initialize("G-VZ37K5438X");

// Component to handle iframe height - calculates actual content height
function IframeHeightHandler() {
  const isInIframe = window.parent !== window.self;

  useEffect(() => {
    // Only send height updates if we're in an iframe
    if (!isInIframe) {
      return;
    }

    // Calculate actual content height
    const getContentHeight = () => {
      const body = document.body;
      const html = document.documentElement;
      
      // Get the maximum height from various measurements
      const heights = [
        body.scrollHeight,
        body.offsetHeight,
        html.scrollHeight,
        html.offsetHeight,
        html.clientHeight
      ];
      
      // Return the maximum valid height
      const maxHeight = Math.max(...heights.filter(h => h > 0 && isFinite(h)));
      return maxHeight || window.innerHeight;
    };
    
    // Send the calculated height to parent
    const sendHeight = () => {
      const height = getContentHeight();
      try {
        window.parent.postMessage(
          { 
            type: 'IFRAME_HEIGHT', 
            height: height,
            source: 'ksol-free-week-trial'
          },
          '*'
        );
      } catch (e) {
        // Ignore cross-origin errors
      }
    };

    // Send height after a short delay to ensure content is rendered
    const timeout = setTimeout(sendHeight, 100);
    
    // Also send on window load
    window.addEventListener('load', sendHeight);
    
    // Send on resize
    window.addEventListener('resize', sendHeight);
    
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('load', sendHeight);
      window.removeEventListener('resize', sendHeight);
    };
  }, [isInIframe]);

  return null;
}

function App() {

  return (
    <HelmetProvider>
      <StateProvider>
        <Router basename="/FreeWeekTrial">
          <IframeHeightHandler />
          <ToastContainer />

          <Routes>
            <Route
              path="/"
              element={<RedirectHandler component={<FreeDownloadsRegister />} />}
            />

            <Route
              path="/studentRegistration"
              element={<ChildRegistration />}
            />
            <Route path="/freeDownloadsRegister" element={<FreeDownloadsRegister />} />
            <Route path="/freeDownloadsPapers" element={<FreeDownloadsOnlyPage />} />
            <Route path="/parentRegistration" element={<ParentRegistration />} />
            <Route path="/loginScreen" element={<LoginScreen />} />
            <Route path="/verification" element={<VerificationScreen />} />
            <Route path="/dashboard" element={<TestsScreen />} />
            <Route path="/takeQuiz" element={<TestTakingScreen />} />
            <Route path="/quizScreen" element={<SummaryScreen />} />
            <Route path="/summaryscreen" element={<SummaryScreen />} />
            <Route path="/summaryScreen" element={<SummaryScreen />} />
            <Route path="/tutorTips" element={<WordFromTutors />} />
          </Routes>
        </Router>
      </StateProvider>
    </HelmetProvider>
  );
}

export default App;
